import React, { createContext } from 'react'
import { DEFAULT_ACCOUNT_CAPABILITIES } from 'constants/General'
import { AccountType } from 'types/accounts'
import { AccountCapabilities } from 'types/capabilities/capabilities'

export interface AccountsData {
  accounts: AccountType[]
  currentAccount: AccountType
  isVerifiedBusinessAccount: boolean
  isDeveloperAccount: boolean
  accountCapabilities: AccountCapabilities
}

export interface AccountsContextType extends AccountsData {
  isLoading: boolean
  shouldShowUKInfoBanner: boolean
}

export interface AccountContextProviderProps {
  accountsData: AccountsData
  isLoading: boolean
  children: React.ReactNode
  shouldShowUKInfoBanner: boolean
}

export const AccountsContext = createContext<AccountsContextType>({
  accounts: [],
  currentAccount: {
    id: null,
    name: '',
    isCurrent: false,
    reference: null,
  },
  isVerifiedBusinessAccount: false,
  isDeveloperAccount: false,
  isLoading: false,
  shouldShowUKInfoBanner: false,
  accountCapabilities: DEFAULT_ACCOUNT_CAPABILITIES,
})

export const AccountsContextProvider = ({
  accountsData,
  isLoading,
  children,
  shouldShowUKInfoBanner,
}: AccountContextProviderProps) => {
  const {
    accounts,
    currentAccount,
    isVerifiedBusinessAccount,
    isDeveloperAccount,
    accountCapabilities,
  } = accountsData || {}

  const value: AccountsContextType = {
    accounts,
    currentAccount,
    isVerifiedBusinessAccount,
    isDeveloperAccount,
    isLoading,
    shouldShowUKInfoBanner,
    accountCapabilities,
  }

  return <AccountsContext.Provider value={value}>{children}</AccountsContext.Provider>
}
